import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClerkProvider } from "@clerk/react";
import { dark } from "@clerk/ui/themes";
import { esES } from "@clerk/localizations";

const appearance = {
  theme: dark,
  captcha: { theme: "dark" },
  variables: {
    colorPrimary: "#00f2a1",
    colorPrimaryForeground: "#05130e",
    colorBackground: "#0d1b1e",
    colorForeground: "#f4f7f6",
    colorInput: "#122a21",
    colorInputForeground: "#f4f7f6",
    colorBorder: "#1b3d30",
    fontFamily: "'IBM Plex Sans', sans-serif",
    borderRadius: "0.75rem",
  },
};

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function ClerkAuthProvider({ children }) {
  const navigate = useNavigate();
  const [config, setConfig] = useState(null);
  const [unavailable, setUnavailable] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const load = async (attempt = 0) => {
      try {
        const cfg = await (await fetch(`${BACKEND_URL}/api/clerk/config`)).json();
        if (cfg.enabled) return cancelled || setConfig(cfg);
      } catch {}
      if (cancelled) return;
      if (attempt >= 20) return setUnavailable(true);
      setTimeout(() => load(attempt + 1), 1500);
    };
    load();
    return () => { cancelled = true; };
  }, []);

  if (unavailable) return <p style={{ padding: 24 }}>El inicio de sesión no está disponible ahora. Recarga la página para intentarlo de nuevo.</p>;
  if (!config) return null;
  return (
    <ClerkProvider
      publishableKey={config.publishable_key}
      proxyUrl={config.proxy_url || undefined}
      appearance={appearance}
      localization={{
        ...esES,
        formFieldInputPlaceholder__password: "Ingresa tu contraseña",
        formFieldInputPlaceholder__signUpPassword: "Crea una contraseña",
        formFieldInputPlaceholder__emailAddress: "nombre@empresa.cl",
        signIn: { ...esES.signIn, start: { ...esES.signIn?.start, title: "Inicia sesión en terraloop.cl", titleCombined: "Inicia sesión en terraloop.cl", subtitle: "Ingresa con tu correo y contraseña", subtitleCombined: "Ingresa con tu correo y contraseña", actionText: "¿No tienes cuenta?", actionLink: "Regístrate" } },
        signUp: { ...esES.signUp, start: { ...esES.signUp?.start, title: "Crea tu cuenta", titleCombined: "Crea tu cuenta", subtitle: "Te enviaremos un código de 6 números para validar tu correo", subtitleCombined: "Te enviaremos un código de 6 números para validar tu correo" } },
      }}
      routerPush={(to) => navigate(to)}
      routerReplace={(to) => navigate(to, { replace: true })}
      signInUrl="/sign-in"
      signUpUrl="/sign-up"
      signInFallbackRedirectUrl="/"
      signUpFallbackRedirectUrl="/"
      afterSignOutUrl="/"
    >
      {children}
    </ClerkProvider>
  );
}
